const React = require("react");
const { UserContextProvider } = require("./src/contexts/UserContext");
const { Helmet } = require("react-helmet");
const {CartContext} = require("./src/contexts/CartContext");
require("./src/styles/tailwind.css");

exports.wrapRootElement = ({ element }) => {
  return (
    <div>
      <CartContext/>
      <UserContextProvider>{element}</UserContextProvider>
    </div>
  );
};
